import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysMaterialInput ( props ) {

    return (

        <BasicCrudScreenType
            id="MomSysZvwInputInspect"
            view="MomSysZvwInputInspect"
            onInitialized = {(grid) => grid.selectionMode = "None"}
        />

    )

}

export default MomSysMaterialInput;
